import { render, staticRenderFns } from "./SaveEditSection.vue?vue&type=template&id=63c59086&scoped=true"
import script from "./SaveEditSection.vue?vue&type=script&lang=js"
export * from "./SaveEditSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c59086",
  null
  
)

export default component.exports